export const strict = false

export const actions = {
  async nuxtServerInit ({ dispatch }) {
    await dispatch('settings/fetchSettings')
    let session = this.$storage.getUniversal('guest-session-id')
    if (session === undefined || session === null) {
      session = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.$storage.setUniversal('guest-session-id', session)
    }
    await dispatch('orders/fetchCart')
  }
}
